/**
 * XPEN-3112 — presentational PDFVisualizer wiring for the unmatched-expense
 * receipt dialog on the credit-card statement page.
 *
 * account_id is an expenses-account id, not an invoice id — same contract as
 * expense.js (XPEN-3006): showInvoiceExports off, document tab, expense prefix.
 */
import React from 'react';
import PDFVisualizer from '../../components/pdf-visualizer.jsx';

export const buildExpenseReceiptVisualizerId = (expense) => {
  if (!expense?.account_id) return '';
  if (expense.checksum) return `${expense.account_id}_${expense.checksum}`;
  return expense.account_id;
};

const ExpenseReceiptPdfViewer = ({ expense, pdfBuff, data, downloadFile }) => (
  <PDFVisualizer
    pdfBuff={pdfBuff}
    data={data}
    downloadFile={downloadFile}
    id={buildExpenseReceiptVisualizerId(expense)}
    showInvoiceExports={false}
    primaryTabLabel={data.t.read('document_tab_label')}
    filenamePrefix="expense"
  />
);

export default ExpenseReceiptPdfViewer;
